var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":_vm.$config.apihost+'/'+_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }